import React, { useState, useEffect } from 'react';
import { Sun, Moon } from 'lucide-react';

const ThemeToggle = () => {
  const [isDark, setIsDark] = useState(() => {
    const saved = localStorage.getItem('nearU_theme');
    // Default to dark mode if no preference saved
    return saved !== 'light';
  });

  useEffect(() => {
    // Apply theme on mount and changes
    if (isDark) {
      document.documentElement.setAttribute('data-theme', 'dark');
      localStorage.setItem('nearU_theme', 'dark');
    } else {
      document.documentElement.removeAttribute('data-theme');
      localStorage.setItem('nearU_theme', 'light');
    }
  }, [isDark]);

  // Set dark theme as default on first render
  useEffect(() => {
    const saved = localStorage.getItem('nearU_theme');
    if (!saved) {
      document.documentElement.setAttribute('data-theme', 'dark');
      localStorage.setItem('nearU_theme', 'dark');
    }
  }, []);

  return (
    <button
      onClick={() => setIsDark(!isDark)}
      data-testid="theme-toggle"
      aria-label={isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
      style={{
        position: 'fixed',
        top: '16px',
        left: '16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        background: isDark 
          ? 'linear-gradient(135deg, rgba(42, 27, 14, 0.95) 0%, rgba(26, 15, 10, 0.98) 100%)' 
          : 'linear-gradient(135deg, #FFFFFF 0%, #F8F6F3 100%)',
        border: '2px solid',
        borderColor: isDark ? 'rgba(212, 175, 55, 0.5)' : 'rgba(165, 124, 51, 0.4)',
        cursor: 'pointer',
        zIndex: 9999,
        boxShadow: isDark 
          ? '0 4px 16px rgba(0, 0, 0, 0.4), 0 0 12px rgba(212, 175, 55, 0.15), inset 0 1px 0 rgba(212, 175, 55, 0.1)' 
          : '0 4px 16px rgba(0, 0, 0, 0.12), 0 0 12px rgba(212, 175, 55, 0.1)',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        backdropFilter: 'blur(12px)',
        padding: 0,
      }}
      title={isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
    >
      {isDark ? (
        <Sun 
          size={20} 
          style={{ 
            color: '#D4AF37', 
            filter: 'drop-shadow(0 0 4px rgba(212, 175, 55, 0.5))',
            transition: 'all 0.3s ease'
          }} 
        />
      ) : (
        <Moon 
          size={20} 
          style={{ 
            color: '#A57C33', 
            filter: 'drop-shadow(0 0 3px rgba(165, 124, 51, 0.3))',
            transition: 'all 0.3s ease'
          }} 
        />
      )}
    </button>
  );
};

export default ThemeToggle;
